import { useState } from "react";
import moment from "moment-timezone";
const useGetCampaignCountdown = () => {
    const [campaignEndsTime, setCampaignEndsTime] = useState(null);
    const [dateCount, setDateCount] = useState(0);
    const [dateUnit, setDateUnit] = useState(null);
    const [isLessThanOneDay, setisLessThanOneDay] = useState(false);
    const [hasEnded, setHasEnded] = useState(false);
    const setEndTime = (finishAt) => {
        if (finishAt) {
            const startDate = moment.utc();
            const endDate = moment(finishAt);
            const timeDifference = getTimeDifference(startDate, endDate);
            if (timeDifference.dateCount <= 0) {
                setHasEnded(true);
            }
            setDateCount(timeDifference.dateCount);
            setDateUnit(timeDifference.dateUnit);
            setCampaignEndsTime(timeDifference.countdownString);
            if (differenceInHours(startDate, endDate) <= 24 && !hasEnded) {
                setisLessThanOneDay(true);
                setInterval(() => {
                    if (!hasEnded) {
                        const startDate = moment.utc();
                        const timeDifference = getTimeDifference(startDate, endDate);
                        if (timeDifference.dateCount <= 0) {
                            setHasEnded(true);
                        }
                        setDateCount(timeDifference.dateCount);
                        setDateUnit(timeDifference.dateUnit);
                        setCampaignEndsTime(timeDifference.countdownString);
                    }
                }, 1000);
            }
        }
    };
    const getEndTimeString = (date, timezone) => {
        if (!date) {
            return null;
        }
        const localTime = moment.tz(date, "YYYY-MM-DD HH:mm:ss", timezone);
        const endDate = localTime.format("D MMM YYYY, h:mma");
        return `${endDate} (${timezone})`;
    };
    const getBrowserEndTimeString = (duration, showTimezone = false) => {
        var _a;
        if (!(duration === null || duration === void 0 ? void 0 : duration.finishAtLocal) || !(duration === null || duration === void 0 ? void 0 : duration.timezone)) {
            return null;
        }
        const localTime = moment.tz(duration.finishAtLocal, "YYYY-MM-DD HH:mm:ss", duration.timezone);
        const browserTime = localTime.clone().tz((_a = moment.tz.guess()) !== null && _a !== void 0 ? _a : "UTC");
        const formattedTime = browserTime.format("D MMM YYYY, h:mma");
        if (showTimezone) {
            return `${formattedTime} ${duration.timezone}`;
        }
        return formattedTime;
    };
    return {
        campaignEndsTime,
        setEndTime,
        isLessThanOneDay,
        dateCount,
        dateUnit,
        getEndTimeString,
        getBrowserEndTimeString,
        hasEnded,
    };
};
const getTimeDifference = (startDate, endDate) => {
    if (differenceInWeeks(startDate, endDate) >= 12) {
        return {
            dateCount: differenceInMonths(startDate, endDate),
            dateUnit: "months",
            countdownString: `${differenceInMonths(startDate, endDate)} months`,
        };
    }
    if (differenceInWeeks(startDate, endDate) >= 2) {
        return {
            dateCount: differenceInWeeks(startDate, endDate),
            dateUnit: "weeks",
            countdownString: `${differenceInWeeks(startDate, endDate)} weeks`,
        };
    }
    if (differenceInDays(startDate, endDate) >= 1) {
        const dayDiff = differenceInDays(startDate, endDate);
        return {
            dateCount: dayDiff,
            dateUnit: dayDiff === 1 ? "day" : "days",
            countdownString: `${dayDiff} ${dayDiff === 1 ? "day" : "days"}`,
        };
    }
    if (differenceInHours(startDate, endDate) >= 1) {
        const hourDiff = differenceInHours(startDate, endDate);
        return {
            dateCount: hourDiff,
            dateUnit: hourDiff === 1 ? "hour" : "hours",
            countdownString: `${hourDiff} ${hourDiff === 1 ? "hour" : "hours"}`,
        };
    }
    if (differenceInMinutes(startDate, endDate) >= 1) {
        const minuteDiff = differenceInMinutes(startDate, endDate);
        const minuteUnit = minuteDiff === 1 ? "minute" : "minutes";
        const secondDiff = differenceInSeconds(startDate, endDate) - (minuteDiff * 60);
        const secondUnit = secondDiff === 1 ? "second" : "seconds";
        const secondString = secondDiff !== 0 ? `, ${secondDiff} ${secondUnit}` : "";
        return {
            dateCount: minuteDiff,
            dateUnit: minuteDiff === 1 ? "minute" : "minutes",
            countdownString: `${minuteDiff} ${minuteUnit}${secondString}`,
        };
    }
    const secondDiff = differenceInSeconds(startDate, endDate);
    return {
        dateCount: secondDiff,
        dateUnit: secondDiff === 1 ? "second" : "seconds",
        countdownString: `${secondDiff} ${secondDiff === 1 ? "second" : "seconds"}`,
    };
};
const differenceInMonths = (startDate, endDate) => endDate.diff(startDate, "months");
const differenceInWeeks = (startDate, endDate) => endDate.diff(startDate, "weeks");
const differenceInDays = (startDate, endDate) => endDate.diff(startDate, "days");
const differenceInHours = (startDate, endDate) => endDate.diff(startDate, "hours");
const differenceInMinutes = (startDate, endDate) => endDate.diff(startDate, "minutes");
const differenceInSeconds = (startDate, endDate) => endDate.diff(startDate, "seconds");
export default useGetCampaignCountdown;
